import Checkout from 'components/features/Checkout/Checkout';
import React from 'react';

const CheckoutPage = () => (
  <>
    <Checkout />
  </>
);

export default CheckoutPage;
